export const activeOptions = [
  { label: 'Active', value: 'active' },
  { label: 'InActive', value: 'inactive' },
]
